import { useEffect, useRef, useState } from "react";
import api from "../utils/api"; // 🔥 ekledik

// 504: sunucu zaman aşımına uğradı ama bitirdiği saatleri cache'ledi; tekrar denemek kalanı tamamlar
const MAX_TIMEOUT_RETRIES = 2;

function errorMessage(err) {
  const body = err?.response?.data;
  if (typeof body === "string" && body.trim()) return body.trim();
  if (body?.error) return body.error;
  return err?.message || "Failed to load location data";
}

export function useLocationData({
  channelId,
  startDate,
  startTime,
  endDate,
  endTime,
  refreshKey,
}) {
  const [data, setData] = useState({ countries: [], subdivisions: [] });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const requestIdRef = useRef(0);

  useEffect(() => {
    if (!channelId || !startDate || !endDate) return;

    const controller = new AbortController();
    const myRequestId = ++requestIdRef.current;

    async function fetchLocation() {
      setLoading(true);
      setError(null);

      try {
        const params = new URLSearchParams({
          channelId,
          startDate,
          endDate,
        });

        if (startTime) params.append("startTime", startTime);
        if (endTime) params.append("endTime", endTime);

        let res;
        for (let attempt = 0; ; attempt++) {
          try {
            res = await api.get(`/location?${params.toString()}`, {
              signal: controller.signal,
            });
            break;
          } catch (err) {
            const retryable =
              err?.response?.status === 504 && attempt < MAX_TIMEOUT_RETRIES;
            if (!retryable || controller.signal.aborted) throw err;
          }
        }

        const json = res.data;

        if (requestIdRef.current !== myRequestId) return;

        setData({
          countries: Array.isArray(json.countries) ? json.countries : [],
          subdivisions: Array.isArray(json.cities) ? json.cities : [],
        });
      } catch (err) {
        if (err.name !== "CanceledError" && requestIdRef.current === myRequestId) {
          setError(errorMessage(err));
        }
      } finally {
        if (requestIdRef.current === myRequestId) {
          setLoading(false);
        }
      }
    }

    fetchLocation();
    return () => controller.abort();
  }, [channelId, startDate, startTime, endDate, endTime, refreshKey]);

  return { data, loading, error };
}